import { useAuthModal } from "../../context/AuthModalContext";
import AuthModalContainer from "../../containers/AuthModal/AuthModalContainer";
import RegisterModalContainer from "../../containers/RegisterModal/RegisterModalContainer";

const GlobalAuthModals = () => {
    const {
        openAuthModal,
        openRegisterModal,
        isGoogleLogin,
        handleCloseAuthModal,
        handleCloseRegisterModal,
        handleSwitchToRegister,
        handleSwitchToLogin
    } = useAuthModal();

    return (
        <>
            <AuthModalContainer
                open={openAuthModal}
                onClose={handleCloseAuthModal}
                onSwitchToRegister={handleSwitchToRegister}
            />
            <RegisterModalContainer
                open={openRegisterModal}
                onClose={handleCloseRegisterModal}
                onSwitchToLogin={handleSwitchToLogin}
                isGoogleLogin={isGoogleLogin}
            />
        </>
    );
};

export default GlobalAuthModals;
